// extracted by mini-css-extract-plugin
module.exports = {"project":"Project_project__3kWsC","footer":"Project_footer__T1gRN","role":"Project_role__2kYDW","title":"Project_title__Wy7gW","subtext":"Project_subtext__iHtzV"};